<template>
<v-menu
  v-model="menu"
  :close-on-content-click="false"
  :nudge-right="40"
  lazy
  transition="scale-transition"
  offset-y
  full-width
  min-width="290px"
>
<v-text-field
  slot="activator"
  :class="errorClass"
  :counter="counter"
  :error-messages="errorMessages"
  :hint="hint"
  :label="label"
  :name="name"
  :prepend-icon="prepend"
  :prepend-icon-cb="prependCb"
  v-model="_value"
  readonly
></v-text-field>
  <v-date-picker v-model="_value" @input="menu = false" 
    :min="min" 
    :max="max" 
    :locale="locale ? locale : default_locale" 
  ></v-date-picker>
</v-menu>
</template>

<script>
import TextInput from './TextAreaInput'
import { mapGetters } from 'vuex'

export default {
  extends: TextInput,
  name: 'date-picker',
  props: {
    min: {
      type: String,
      required: false,
      default: null
    },
    max: {
      type: String,
      required: false,
      default: null
    },
    locale: {
      type: String,
      required: false,
      default: this.default_locale
    }
  },
  data() {
    return {
      menu: false,
    }
  },
  computed: mapGetters({
    default_locale: 'locale'
  }),
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/form/DatePicker.vue